import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import Logo from '../Logo';

import { ta, adminLocale } from '../../i18n/adminT';
const DOC_TYPE_LABELS = {
  carta_identita: "Carta d'identità",
  patente: 'Patente',
  passaporto: 'Passaporto',
};

function formatDateTime(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return {
    date: d.toLocaleDateString(adminLocale(), { day: '2-digit', month: 'long', year: 'numeric' }),
    time: d.toLocaleTimeString(adminLocale(), { hour: '2-digit', minute: '2-digit' }),
  };
}

function Field({ label, value }) {
  return (
    <div className="contract-field">
      <span className="contract-field-label">{label}</span>
      <span className="contract-field-value">{value || '—'}</span>
    </div>
  );
}

export default function RegistrationDetailModal({ registrationId, onClose }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');
    api.getRegistrationDetail(registrationId)
      .then((res) => { if (mounted) setData(res.data); })
      .catch((err) => { if (mounted) setError(err.message); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, [registrationId]);

  const entered = data ? formatDateTime(data.registered_at) : null;
  const exited = data?.exit_at ? formatDateTime(data.exit_at) : null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card modal-card--wide contract-modal" onClick={(e) => e.stopPropagation()}>
        {loading && <p style={{ color: 'var(--muted-text)' }}>{ta('Caricamento…')}</p>}
        {error && <div className="form-error">{error}</div>}

        {data && (
          <div className="contract-sheet" id="contract-print-area">
            <div className="contract-header">
              <Logo size={40} />
              <div className="contract-header-meta">
                <div className="contract-doc-title">{ta('Registrazione visitatore')}</div>
                <div className="contract-doc-ref">{ta('Rif. #')}{String(data.id).padStart(6, '0')}{entered ? ` · ${entered.date}` : ''}</div>
              </div>
            </div>

            <div className="contract-hero">
              <div className="contract-hero-name">{data.nome} {data.cognome}</div>
              {data.ditta && <div className="contract-hero-sub">{data.ditta}</div>}
            </div>

            <div className="contract-grid">
              <Field label={ta('Numero badge')} value={data.numero_badge} />
              <Field label={ta('Dispositivo')} value={data.device_label} />
              <Field label={ta('Persona di riferimento')} value={data.persona_riferimento} />
              <Field label={ta('Email')} value={data.email} />
              <Field
                label={ta('Documento')}
                value={data.tipo_documento ? `${ta(DOC_TYPE_LABELS[data.tipo_documento]) || data.tipo_documento}${data.numero_documento ? ' · ' + data.numero_documento : ''}` : null}
              />
              <Field label={ta('Ingresso')} value={entered ? `${entered.date} · ${entered.time}` : null} />
              <Field label={ta('Uscita')} value={exited ? `${exited.date} · ${exited.time}` : ta('In corso')} />
            </div>

            <div className="contract-consents">
              <div className={`contract-consent ${data.privacy_accepted ? 'is-accepted' : ''}`}>
                <span className="contract-consent-mark">{data.privacy_accepted ? '✓' : '✕'}</span>
                {ta('Informativa privacy')} {data.privacy_accepted ? ta('accettata') : ta('non accettata')}
              </div>
              <div className={`contract-consent ${data.security_accepted ? 'is-accepted' : ''}`}>
                <span className="contract-consent-mark">{data.security_accepted ? '✓' : '✕'}</span>
                {ta('Informativa sicurezza')} {data.security_accepted ? ta('accettata') : ta('non accettata')}
              </div>
            </div>

            {data.note && (
              <div className="contract-note">
                <span className="contract-field-label">{ta('Note')}</span>
                <p>{data.note}</p>
              </div>
            )}

            <div className="contract-signature">
              <span className="contract-field-label">{ta('Firma')}</span>
              {data.signature_data ? (
                <img src={data.signature_data} alt={ta('Firma')} className="contract-signature-img" />
              ) : (
                <div className="contract-signature-empty">{ta('Nessuna firma raccolta')}</div>
              )}
            </div>
          </div>
        )}

        <div className="btn-row contract-actions">
          {data && (
            <button type="button" className="btn btn-ghost" onClick={() => window.print()}>{ta('🖨️ Stampa')}</button>
          )}
          <button type="button" className="btn btn-primary" onClick={onClose}>{ta('Chiudi')}</button>
        </div>
      </div>
    </div>
  );
}
